export default __webpack_public_path__ + "static/escenarios_home-b7498df8c6614935c021aaa2d767e1fc.png";